/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS45OTk5OSAxNS44MzMyVjQuMTY2NU05Ljk5OTk5IDQuMTY2NUw0LjE2NjY2IDkuOTk5ODRNOS45OTk5OSA0LjE2NjVMMTUuODMzMyA5Ljk5OTg0IiBzdHJva2U9IiMxODFEMjciIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";